import React from 'react';
import CoverImageSecond from './CoverImageSecond';
import Service6 from './Service6';
import Service6Second from './Service6Second';
import ReservationForm from './ReservationForm';



import Footer from './Footer';


const Preshoot = () => {
    return (
        <div>
            <CoverImageSecond />
            <Service6 />
            <Service6Second />
            <ReservationForm />


            <Footer/>

        </div>
    );
};

export default Preshoot;